export default __webpack_public_path__ + "static/media/blog-img246.1256040b.jpg";